window.addEventListener('load', function() {
    (function () {
        const elements = {
            shippingBar: document.querySelector('.cart-gamification__message--free-shipping'),
            giftBar: document.querySelector('.cart-gamification__message--gift'),
            progressShipping: document.querySelector('.cart-gamification__progress-bar--free-shipping'),
            progressGift: document.querySelector('.cart-gamification__progress-bar--gift'),
            progressFill: document.querySelector('.cart-gamification__progress-bar-fill'),
            progressShippingText: document.querySelector('.cart-gamification__progress-bar-header--shipping'),
            progressGiftText: document.querySelector('.cart-gamification__progress-bar-header--gift'),
            progressContainer: document.querySelector('.cart-gamification__progress-bar'),
            progressHeader: document.querySelector('.cart-gamification__progress-header'),
        };
    
        const thresholds = {
            shipping: elements.shippingBar ? parseFloat(elements.shippingBar.dataset.shippingThreshold) || 0 : 0,
            gift: elements.giftBar ? parseFloat(elements.giftBar.dataset.giftThreshold) || 0 : 0,
        };

        const giftSettings = {
            productId: elements.giftBar ? elements.giftBar.dataset.giftProduct : null,
            variantId: elements.giftBar ? elements.giftBar.dataset.giftVariant : null,
        };

        const excludedProductIds = elements.progressHeader 
            ? (elements.progressHeader.dataset.collectionExclude || '').split(',').map(id => id.trim()).filter(id => id)
            : [];

        let currentCart = null;
        let isCartUpdating = false;
        let isSystemRemovingGift = false;
        
        const STORAGE_KEY = 'cart_gamification_gift_removed';
        const STORAGE_CART_COUNT = 'cart_gamification_last_count';
        
        let giftManuallyRemoved = localStorage.getItem(STORAGE_KEY) === 'true';
        let lastCartItemCount = parseInt(localStorage.getItem(STORAGE_CART_COUNT) || '0', 10);

        // =======================================================
        // UTILITY FUNCTIONS
        // =======================================================

        function isProductExcluded(productId) {
            return excludedProductIds.includes(productId.toString());
        }

        function calculateCartTotalExcludingProducts(cart) {
            if (!cart || !cart.items) return 0;

            const includedItems = cart.items.filter(item => {
                if (isProductExcluded(item.product_id)) return false;
                
                if (item.properties && item.properties._gift === 'true') return false;
                
                return true;
            });

            const total = includedItems.reduce((sum, item) => {
                return sum + (item.final_line_price || 0);
            }, 0);

            return total / 100; 
        }

        async function safeFetchAndUpdate(url, config, isUpdateOperation) {
            let result;
            try {
                if (isUpdateOperation) {
                    isCartUpdating = true;
                }

                const response = await fetch(url, config);
                if (!response.ok) {
                    throw new Error(`Fetch failed with status ${response.status}`);
                }
                result = await response.json();

                if (isUpdateOperation) {
                    const cartResponse = await fetch('/cart.js');
                    const fullCart = await cartResponse.json();

                    const combinedCartData = {
                        ...fullCart,
                        sections: result.sections || {}
                    };
                    
                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                        sources: 'cart-gamification',
                        cart: combinedCartData,
                    });
                }
            } catch (error) {
                console.warn('Cart operation error:', error);
            } finally {
                if (isUpdateOperation) {
                    isCartUpdating = false;
                }
            }
            return result;
        }

        // =======================================================
        // GIFT REMOVAL DETECTION
        // =======================================================

        function detectManualGiftRemoval(cart, previousCart) {
            if (!previousCart || !cart) return;

            const hadGift = previousCart.items.some(item => 
                item.properties && item.properties._gift === 'true'
            );

            const hasGift = cart.items.some(item => 
                item.properties && item.properties._gift === 'true'
            );

            if (hadGift && !hasGift && !isCartUpdating && !isSystemRemovingGift) {
                giftManuallyRemoved = true;
                localStorage.setItem(STORAGE_KEY, 'true');
            }
            
            if (isSystemRemovingGift && !hasGift) {
                isSystemRemovingGift = false;
            }
        }

        function checkIfCartWasEmptied(cart) {
            const currentItemCount = cart.items.length;
            
            if (currentItemCount === 0 && lastCartItemCount > 0) {
                console.log('Cart was emptied - resetting all flags');
                giftManuallyRemoved = false;
                localStorage.setItem(STORAGE_KEY, 'false');
                
                resetProgressBar();
            }
            
            lastCartItemCount = currentItemCount;
            localStorage.setItem(STORAGE_CART_COUNT, currentItemCount.toString());
        }

        function resetProgressBar() {
            if (elements.progressShipping) {
                elements.progressShipping.style.width = '0%';
            }
            if (elements.progressGift) {
                elements.progressGift.style.width = '0%';
            }

            ['shipping', 'gift'].forEach(type => {
                const barContainer = document.querySelector(`.cart-gamification__progress-icon--${type}`);
                const barElement = document.querySelector(`.cart-gamification__progress-bar--${type === 'shipping' ? 'free-shipping' : type}`);
                const barContainerElement = document.querySelector(`.cart-gamification__progress-bar-container[data-type="${type}"]`);
                const headerElement = document.querySelector(`.cart-gamification__progress-bar-header--${type}`);
                
                [barContainer, barElement, barContainerElement, headerElement].forEach(el => {
                    if (el) {
                        el.classList.remove('is-completed', 'in-progress');
                    }
                });
            });

            document.querySelectorAll('.cart-gamification__message').forEach(msg => msg.classList.add('dn-i'));
            
            if (elements.shippingBar) {
                const template = elements.shippingBar.dataset.shippingMessage || 'You are RS **amount** away from free shipping';
                const message = template.replace("**amount**", thresholds.shipping.toFixed(2));
                elements.shippingBar.innerHTML = message;
                elements.shippingBar.classList.remove('dn-i');
            }
        }

        // =======================================================
        // CALCULATIONS AND RENDERING
        // =======================================================
        
        function calculateProgress(cartTotal, cartDiscounts) {
            const totalDiscount = cartDiscounts.reduce((sum, discount) => {
                const amount = parseFloat(discount.total_allocated_amount || discount.amount) / 100;
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);
    
            const effectiveTotal = cartTotal + totalDiscount;
            
            const activeThresholds = [];
            if (elements.shippingBar && thresholds.shipping > 0) {
                activeThresholds.push({ type: 'shipping', value: thresholds.shipping });
            }
            if (elements.giftBar && thresholds.gift > 0) {
                activeThresholds.push({ type: 'gift', value: thresholds.gift });
            }
            
            activeThresholds.sort((a, b) => a.value - b.value);
    
            const progress = {
                shippingPercentage: 0,
                giftPercentage: 0,
                shippingMessage: "",
                giftMessage: "",
                activeIconBar: activeThresholds[0]?.type || 'shipping',
                fillBlack: false,
                currentThresholdIndex: 0,
            };
    
            for (let i = 0; i < activeThresholds.length; i++) {
                const currentThreshold = activeThresholds[i];
                const previousThreshold = i > 0 ? activeThresholds[i - 1] : { value: 0 };
                
                const segmentTotal = currentThreshold.value - previousThreshold.value;
                const segmentProgress = Math.max(0, effectiveTotal - previousThreshold.value);
                const percentage = Math.min((segmentProgress / segmentTotal) * 100, 100);
                
                if (currentThreshold.type === 'shipping') {
                    progress.shippingPercentage = percentage;
                } else if (currentThreshold.type === 'gift') {
                    progress.giftPercentage = percentage;
                }
                
                if (effectiveTotal < currentThreshold.value) {
                    progress.activeIconBar = currentThreshold.type;
                    progress.currentThresholdIndex = i;
                    break;
                } else if (i === activeThresholds.length - 1) {
                    progress.activeIconBar = currentThreshold.type;
                    progress.fillBlack = true;
                    progress.currentThresholdIndex = i;
                } else {
                    continue;
                }
            }
    
            if (elements.shippingBar) {
                if (effectiveTotal >= thresholds.shipping) {
                    progress.shippingMessage = elements.shippingBar.dataset.shippingUnlock || 'Free shipping unlocked!';
                } else {
                    const remainingAmount = Math.max(0, thresholds.shipping - effectiveTotal);
                    const template = elements.shippingBar.dataset.shippingMessage || 'You are RS **amount** away from free shipping';
                    progress.shippingMessage = template.replace("**amount**", remainingAmount.toFixed(2));
                }
            }

            if (elements.giftBar) {
                if (effectiveTotal >= thresholds.gift) {
                    progress.giftMessage = elements.giftBar.dataset.giftUnlock || 'Free gift unlocked!';
                } else {
                    const remainingAmount = Math.max(0, thresholds.gift - effectiveTotal);
                    const template = elements.giftBar.dataset.giftMessage || 'Spend RS **amount** more for free gift';
                    progress.giftMessage = template.replace("**amount**", remainingAmount.toFixed(2));
                }
            }
            
            return progress;
        }
        
        function renderProgress(progress) {
            elements.shippingBar && elements.progressShipping && (elements.progressShipping.style.width = `${progress.shippingPercentage}%`);
            elements.giftBar && elements.progressGift && (elements.progressGift.style.width = `${progress.giftPercentage}%`);

            document.querySelectorAll('.cart-gamification__message').forEach(msg => msg.classList.add('dn-i'));

            if (progress.activeIconBar === 'shipping' && elements.shippingBar) {
                elements.shippingBar.innerHTML = progress.shippingMessage;
                elements.shippingBar.classList.remove('dn-i');
            }
            if (progress.activeIconBar === 'gift' && elements.giftBar) {
                elements.giftBar.innerHTML = progress.giftMessage;
                elements.giftBar.classList.remove('dn-i');
            }

            const cartTotal = calculateCartTotalExcludingProducts(currentCart);
            const cartDiscounts = currentCart?.cart_level_discount_applications || [];
            const totalDiscount = cartDiscounts.reduce((sum, discount) => {
                const amount = parseFloat(discount.total_allocated_amount || discount.amount) / 100;
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);
            const effectiveTotal = cartTotal + totalDiscount;

            ['shipping', 'gift'].forEach(type => {
                const barContainer = document.querySelector(`.cart-gamification__progress-icon--${type}`);
                const barElement = document.querySelector(`.cart-gamification__progress-bar--${type === 'shipping' ? 'free-shipping' : type}`);
                const barContainerElement = document.querySelector(`.cart-gamification__progress-bar-container[data-type="${type}"]`);
                const headerElement = document.querySelector(`.cart-gamification__progress-bar-header--${type}`);
                
                if (!barContainer || !barElement) return;

                const threshold = thresholds[type];
                const percentage = progress[`${type}Percentage`];

                [barContainer, barElement, barContainerElement, headerElement].forEach(el => {
                    if (el) {
                        el.classList.remove('is-completed', 'in-progress');
                    }
                });

                if (effectiveTotal >= threshold) {
                    [barContainer, barElement, barContainerElement, headerElement].forEach(el => {
                        if (el) el.classList.add('is-completed');
                    });
                } else if (percentage > 0) {
                    [barContainer, barElement, barContainerElement, headerElement].forEach(el => {
                        if (el) el.classList.add('in-progress');
                    });
                }
            });
        }
        
        // =======================================================
        // GIFT PRODUCT HANDLING - CORREGIDO
        // =======================================================

        async function handleGiftProduct(cart, effectiveTotal) {
            if (!elements.giftBar || !giftSettings.productId) return;

            const giftThresholdMet = effectiveTotal >= thresholds.gift;
            
            const giftItem = cart.items.find(item => 
                item.product_id.toString() === giftSettings.productId.toString() &&
                item.properties && item.properties._gift === 'true'
            );

            try {
                if (giftThresholdMet) {
                    if (!giftItem && !giftManuallyRemoved) {
                        const variantId = giftSettings.variantId || await getDefaultVariantId(giftSettings.productId);
                        if (variantId) await addGiftToCart(variantId);
                    } else if (giftItem && giftItem.quantity !== 1 && !giftManuallyRemoved) {
                        await enforceGiftQuantity(giftItem.key);
                    }
                } else if (giftItem) {
                    isSystemRemovingGift = true;
                    await removeGiftFromCart(cart);
                }
            } catch (error) {
                console.warn('Gift product handling error:', error);
                isSystemRemovingGift = false;
            }
        }
        
        // =======================================================
        // OPERATION SUPPORT FUNCTIONS
        // =======================================================

        async function getDefaultVariantId(productId) {
            try {
                const response = await fetch(`/products/${productId}.js`);
                const product = await response.json();
                return product.variants[0]?.id;
            } catch (error) {
                console.warn('Error fetching product variants:', error);
                return null;
            }
        }

        async function addGiftToCart(variantId) {
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );

            const body = JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: { '_gift': 'true', '_gift_message': 'Free Gift - Do Not Remove' },
                sections: sectionsToBundle
            });

            await safeFetchAndUpdate(`${FoxTheme.routes.cart_add_url}`, { 
                ...FoxTheme.utils.fetchConfig(), 
                ...{ body } 
            }, true);
        }

        async function enforceGiftQuantity(itemKey) {
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );

            const body = JSON.stringify({ 
                id: itemKey, 
                quantity: 1, 
                sections: sectionsToBundle 
            });

            await safeFetchAndUpdate(`${FoxTheme.routes.cart_change_url}`, { 
                ...FoxTheme.utils.fetchConfig(), 
                ...{ body } 
            }, true);
        }

        async function removeGiftFromCart(cart) {
            const giftItems = cart.items.filter(item => 
                item.properties && item.properties._gift === 'true'
            );
            if (giftItems.length === 0) return;

            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );

            const body = JSON.stringify({ 
                id: giftItems[0].key, 
                quantity: 0, 
                sections: sectionsToBundle 
            });

            await safeFetchAndUpdate(`${FoxTheme.routes.cart_change_url}`, { 
                ...FoxTheme.utils.fetchConfig(), 
                ...{ body } 
            }, true);
        }
        
        // =======================================================
        // MAIN FLOW CONTROL
        // =======================================================

        async function updateProgress(cart) {
            if (isCartUpdating) { 
                return;
            }
            
            checkIfCartWasEmptied(cart);
            
            if (!cart || !cart.items || cart.items.length === 0) {
                console.log('Cart is empty, skipping further processing');
                currentCart = cart;
                return;
            }
            
            if (currentCart) {
                detectManualGiftRemoval(cart, currentCart);
            }
            
            currentCart = cart;
            
            if (typeof cart.total_price === 'undefined') {
                console.warn('Invalid cart data:', cart);
                return;
            }
            
            const cartTotal = calculateCartTotalExcludingProducts(cart);
            const cartDiscounts = cart.cart_level_discount_applications || [];
            const progress = calculateProgress(cartTotal, cartDiscounts);
            
            renderProgress(progress);
            
            const totalDiscount = cartDiscounts.reduce((sum, discount) => {
                const amount = parseFloat(discount.total_allocated_amount || discount.amount) / 100;
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);
            const effectiveTotal = cartTotal + totalDiscount;
            
            await handleGiftProduct(cart, effectiveTotal);
        }

        async function getInitialCart() {
            try {
                const cart = await safeFetchAndUpdate(`${FoxTheme.routes.cart_url}`, {
                    ...FoxTheme.utils.fetchConfig()
                }, false);
                
                lastCartItemCount = cart.items.length;
                localStorage.setItem(STORAGE_CART_COUNT, lastCartItemCount.toString());
                
                await updateProgress(cart);
            } catch (error) {
                console.warn('Error getting initial cart:', error);
            }
        }
    
        function orderElementsByThreshold() {
            const progressHeader = document.querySelector('.cart-gamification__progress-header');
            const progressSection = document.querySelector('.cart-gamification__progress');
            
            if (!progressHeader || !progressSection) return;
            
            const headers = Array.from(progressHeader.querySelectorAll('.cart-gamification__progress-bar-header'));
            const progressBars = Array.from(progressSection.querySelectorAll('.cart-gamification__progress-bar-container'));
            
            headers.sort((a, b) => {
                const thresholdA = parseFloat(a.dataset.threshold) || 0;
                const thresholdB = parseFloat(b.dataset.threshold) || 0;
                return thresholdA - thresholdB;
            });
            
            progressBars.sort((a, b) => {
                const thresholdA = parseFloat(a.dataset.threshold) || 0;
                const thresholdB = parseFloat(b.dataset.threshold) || 0;
                return thresholdA - thresholdB;
            });
            
            const enabledCount = parseInt(progressHeader.dataset.enabledCount) || headers.length;
            
            headers.forEach((header, index) => {
                header.classList.remove('block-1', 'block-2', 'block-3', 'block-full');
                
                if (enabledCount === 1) {
                    header.classList.add('block-full');
                } else if (enabledCount === 2) {
                    header.classList.add(index === 0 ? 'block-1' : 'block-2');
                } else {
                    if (index === 0) header.classList.add('block-1');
                    else if (index === 1) header.classList.add('block-2');
                    else header.classList.add('block-3');
                }
                
                progressHeader.appendChild(header);
            });
            
            progressBars.forEach((bar, index) => {
                bar.classList.remove('block-1', 'block-2', 'block-3', 'block-full');
                
                if (enabledCount === 1) {
                    bar.classList.add('block-full');
                } else if (enabledCount === 2) {
                    bar.classList.add(index === 0 ? 'block-1' : 'block-2');
                } else {
                    if (index === 0) bar.classList.add('block-1');
                    else if (index === 1) bar.classList.add('block-2');
                    else bar.classList.add('block-3');
                }
                
                const fillElement = progressSection.querySelector('.cart-gamification__progress-bar-fill');
                progressSection.insertBefore(bar, fillElement);
            });
        }

        function setupGiftRemovalDetection() {
            document.addEventListener('click', (event) => {
                const removeButton = event.target.closest('[data-gift-variant-in-cart="true"]');
                
                if (removeButton) {
                    giftManuallyRemoved = true;
                    localStorage.setItem(STORAGE_KEY, 'true');
                }
            }, true);
        }

        function initializeCart() {
            orderElementsByThreshold();
            
            getInitialCart();
            
            setupGiftRemovalDetection();
            
            document.addEventListener('cart:updated', (event) => {
                if (event.detail.cart) {
                    updateProgress(event.detail.cart);
                }
            });

            if (window.FoxTheme && window.FoxTheme.pubsub) {
                FoxTheme.pubsub.subscribe(
                    FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                    (data) => {
                        if (data.cart && data.sources !== 'cart-gamification') { 
                            updateProgress(data.cart);
                        }
                    }
                );
            }

            document.addEventListener('product-ajax:added', () => {
                setTimeout(getInitialCart, 100);
            });
        }
    
        initializeCart();
    })();
});